import { render, staticRenderFns } from "./test.component.vue?vue&type=template&id=fb208c52&scoped=true&"
import script from "./test.component.js?vue&type=script&lang=js&"
export * from "./test.component.js?vue&type=script&lang=js&"
import style0 from "./test.component.scss?vue&type=style&index=0&id=fb208c52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb208c52",
  null
  
)

export default component.exports